//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector  } from 'react-redux'
// import * as action from "./actions"

const getAllSlides = (state) => state.getAllSlides
const openSlideWidget = (state) => state.openSlideWidget;

//  -- Examples array selector --------

export const useGetAllSlidesData = () => {
    const selectedData = useSelector(getAllSlides, shallowEqual)
    return selectedData;
}

export const useOpenSlideWidget = () => {
    const selectedData = useSelector(openSlideWidget, shallowEqual)
    return selectedData;
}



